export default __webpack_public_path__ + "static/media/forestly-noexpl-02_EN.d67ddfc3.png";